import React from 'react'
import { motion } from 'framer-motion'
import Projects from '../components/Projects'
import './ProjectsPage.css'

const ProjectsPage = () => {
  return (
    <div className="projects-page">
      <div className="container">
        <motion.div
          className="page-header"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="page-title">My Projects</h1>
          <p className="page-description">
            Explore my portfolio of web applications, mobile apps, and creative projects.
            Each project represents my passion for building exceptional digital experiences.
          </p>
        </motion.div>
        <Projects />
      </div>
    </div>
  )
}

export default ProjectsPage
